import { Route, Routes } from 'react-router-dom';

import { DomainsListPage, DomainDetailsPage, isCacheSettingsAllowedByPlan } from '../features/domain-manager';
import requireAuth from '../components/hocs/requireAuth';
import useFeatureFlag, { FeatureFlag } from '../hooks/useFeatureFlag';
import Error404Page from './Error404Page';
import { useCharbeePlanId } from '../hooks/usePrerenderUser';

function DomainsManagerPage() {
  const chargebeePlanId = useCharbeePlanId();
  const canUseDomainDetails = useFeatureFlag([FeatureFlag.DomainsDetails]);
  const canUseSchedulerSettings = useFeatureFlag([FeatureFlag.DomainSchedulerSettings]);

  const isDetailsPageAvailable =
    canUseDomainDetails || canUseSchedulerSettings || isCacheSettingsAllowedByPlan(chargebeePlanId);

  return (
    <Routes>
      <Route path="" element={<DomainsListPage />} />
      {isDetailsPageAvailable && <Route path=":domain" element={<DomainDetailsPage />} />}
      <Route path="*" element={<Error404Page />} />
    </Routes>
  );
}

export default requireAuth(DomainsManagerPage);
